import VentaModal from "./VentaModal";
export default VentaModal;